import React, { useContext, useEffect, useState } from 'react'
import { Button, ButtonGroup, Card, Col, Form, Modal, Row, Table } from 'react-bootstrap'
import { CompanyContext } from './CompanyContext'
import ResalesRequestService from 'services/resales-request';
import { maskDocument, maskZip } from 'helpers/document';
import { formatMoney } from 'helpers/Currency';
import { toast } from 'react-toastify';
import { Clear, Edit } from '@material-ui/icons';
import ViaCepRequest from 'services/viacep-request';
import { useCompany, useUser } from 'models';

export default function CompanyGroup() {
  const user = useUser()
  const {id: fiscalYear } = JSON.parse(localStorage.getItem('Elite:fiscalYear')) ?? {}
  const { company } = useCompany()
  const [currentFiscalYear] = useState(user.fiscal_year)
  const [companyGroupId, setCompanyGroupId] = useState(() => {
    let list = company.all_company_fiscal_years;
    if(!!!list){
      list = company.fiscal_year.map(a=>{return a.pivot})
    }
    return list.find(year => year.fiscal_year_id == fiscalYear)?.company_group_id
  })
  const [companyGroup, setCompanyGroup] = useState([]);
  const [companyToSave, setCompanyToSave] = useState({
    name: company.name,
    alias: company.company_name
  })
  const [showCompanyModal, setShowCompanyModal] = useState(false)

  useEffect(() => {
    if (fiscalYear) {
      getCompanyGroup()
    }
  }, [])

  const premiumLabel = is_premium => {
    if (is_premium == 1) {
      return "Elite"
    } else if (is_premium == 2) {
      return "Elite Gerencial"
    } else if (is_premium == 3) {
      return "ScanCash"
    } else if (is_premium == 4) {
      return "Elite Pass"
    } else if (is_premium == 5) {
      return "ScanSource Select"
    }

    return "outros"
  }

  function getCompanyGroup() {
    const renderActionsButton = company_id => {
      return (
        <ButtonGroup>
          <Button
              size="sm"
              variant="info"
              onClick={() => {
                // if (user.birthday === null)
                //   setBirthday(null)
                // else
                //   setBirthday(new Date(`${user.birthday} 00:00:00`))
                  
                // const _user = { ...user }
                // _user['action'] = "update"
                // setUserToSave(_user)
                // handleShowUserModal()
              }}
            >
              <Edit fontSize="small" />
            </Button>
          <Button
            onClick={() => {
              toast.success(company_id)
            }}
            size="sm"
            variant="danger"
          >
            <Clear fontSize="small" />
          </Button>
        </ButtonGroup>
      )
    }
    
    ResalesRequestService
      .getCompanyGroup(company.company_group_id ?? companyGroupId, {
        params: {
          '__fiscal_year': fiscalYear
        }
      })
      .then(({ data: response }) => {
        const { data } = response
        const result = data.map(item => ({
          id: item.id,
          premium: premiumLabel(item.is_premium),
          name: item.name,
          document: maskDocument(item.document),
          value: formatMoney(item.value),
          //actions: renderActionsButton(company.id)
        }))
        setCompanyGroup(result)
      })
  }

  const setValue = (name, value) => {
    let _company = { ...companyToSave };
    _company[name] = value;
    setCompanyToSave({ ..._company });
  }

  const handleClose = () => setShowCompanyModal(false)

  const setAddressData = async (cep) => {
    const cepData = await ViaCepRequest.cepData(cep)
    setCompanyToSave({ 
      ...companyToSave,
      address_zipcode: cepData.cep,
      address: cepData.logradouro,
      address_neighborhood: cepData.bairro,
      address_city: cepData.localidade,
      address_state: cepData.uf
    })
  }

  const handleSubmit = () => {
    var formData = new FormData()
    formData.append('company[name]', companyToSave.name)
    formData.append('company[alias]', companyToSave.alias)
    formData.append('company[document]', companyToSave.document)

    formData.append('cfy[company_group_id]', company.company_group_id)
    formData.append('cfy[company_type_id]', company.company_type_id)
    formData.append('cfy[is_premium]', company.is_premium)
    formData.append('cfy[is_masteragent]', company.is_masteragent)
    formData.append('cfy[fiscal_year_id]', fiscalYear)
    ResalesRequestService.store(formData)
      .then(() => {
        getCompanyGroup()
        setShowCompanyModal(false)
      })
  }

  return (<>
    <Card className="mt-2 shadow">
      <Card.Body>
        <Row>
          <Col md="12" className="d-flex justify-content-between">
            <h6 className="title-dashboard">Grupo e Faturamento</h6>
            {/* <Button size='sm' variant="success" onClick={() => setShowCompanyModal(true)}>
              <FontAwesomeIcon icon={faPlus} /> Adicionar Filal
            </Button> */}
          </Col>
          <Col><hr className="line"></hr></Col>
          <Col md="12">
            <Table striped bordered size='sm'>
              <thead>
                <tr>
                  <th className='text-center'>Classificação</th>
                  <th className='text-center'>Razão Social</th>
                  <th className='text-center'>CNPJ</th>
                  <th className='text-center'>Faturamento</th>
                  {/* <th className='text-center'>Ação</th> */}
                </tr>
              </thead>
              <tbody>
                {companyGroup.map((item) => {
                  return (
                    <tr key={item.id} className={item.id == company.id ? "table-warning" : ""}>
                      <td className='text-center'>{item.premium}</td>
                      <td className='text-center'>{item.name}</td>
                      <td className='text-center'>{item.document}</td>
                      <td className='text-center'>{item.value}</td>                      
                      {/* <td className='text-center'>{item.id != company.id ? item.actions : null}</td> */}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card.Body>
    </Card>

    <Modal
      size='lg'
      backdrop="static"
      keyboard={false}
      centered
      show={showCompanyModal}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Cadastrar Nova Filial</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md="12">
              <h5 className="title-dashboard">Dados da Revenda</h5>
              <hr className="line"></hr>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Razão Social:</Form.Label>
                <Form.Control
                  as="input"
                  disabled                
                  value={companyToSave.name}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Nome Fantasia:</Form.Label>
                <Form.Control
                  as="input"
                  disabled
                  value={companyToSave.alias}
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Label>CNPJ:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => setValue("document", e.target.value)}
                  value={maskDocument(companyToSave.document ?? "")}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h5 className="title-dashboard">Endereço</h5>
              <hr className="line"></hr>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>CEP:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => {
                    if (e.target.value.length >= 8) {
                      setAddressData(e.target.value)
                    }                    
                    setValue("address_zipcode", e.target.value)
                  }}
                  value={maskZip(companyToSave.address_zipcode ?? "")}
                />
              </Form.Group>
            </Col>
            <Col md={8}>
              <Form.Group>
                <Form.Label>Av. / Rua:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={true}
                  value={companyToSave.address ?? ""}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Número:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => setValue("address_number", e.target.value)}
                  value={companyToSave.address_number ?? ""}
                />
              </Form.Group>
            </Col>
            <Col md={10}>
              <Form.Group>
                <Form.Label>Complemento:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => setValue("address_complement", e.target.value)}
                  value={companyToSave.address_complement ?? ""}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Bairro:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={true}
                  value={companyToSave.address_neighborhood ?? ""}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Cidade:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={true}
                  value={companyToSave.address_city ?? ""}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Estado:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={true}
                  value={companyToSave.address_state ?? ""}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  </>)
}